const baseResource = "api/employee-beneficiaries";

export const employeeBeneficiariesResource = {
  list: (employeeId: number | string) => `api/employees/${employeeId}/beneficiaries`,
  create: (employeeId?: number | string) => (
    employeeId ? `api/employees/${employeeId}/beneficiaries` : baseResource
  ),
  update: (id: number | string) => `${baseResource}/${id}`,
  delete: (id: number | string) => `${baseResource}/${id}`,
  show: (id: number | string) => `${baseResource}/${id}`
};
